<template>
  <div>
    <!-- Header with back button -->
    <div class="border-b border-gray-200 pb-3 mb-4">
      <button @click="$emit('back')" class="flex items-center text-xs text-gray-600 hover:text-gray-900 mb-2">
        <ArrowLeftIcon class="h-4 w-4 mr-1" />
        Retour
      </button>
      <h2 class="text-sm text-black">Commander un KIT de PLV</h2>
    </div>

    <div v-if="filteredContractDistributions.length === 0" class="text-center py-8 text-gray-500">
      Aucun kit de PLV disponible pour le moment.
    </div>

    <div v-else class="space-y-4 max-h-96 overflow-y-auto">
      <div
        v-for="contractDistribution in filteredContractDistributions"
        :key="contractDistribution.id"
        class="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors"
      >
        <div class="flex items-center justify-between">
          <div class="flex-1">
            <h3 class="text-lg font-semibold text-gray-900 mb-2">
              {{ $t(`contract_distributions.category.${contractDistribution.category}`) }}
            </h3>
          </div>
          <div class="flex items-center ml-4 gap-4">
            <div class="flex items-center gap-4 text-sm text-gray-600">
              <a
                v-if="contractDistribution.kitLink"
                :href="contractDistribution.kitLink"
                class="text-primary-dark underline cursor-pointer hover:text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Voir le kit
              </a>
            </div>
            <SecondaryButton @click="handleOrderKit(contractDistribution)">Commander</SecondaryButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArrowLeftIcon } from "@heroicons/vue/outline";
import { SecondaryButton } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    ArrowLeftIcon,
    SecondaryButton,
  },
  emits: ["back"],
  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
    ...mapState("contractDistributions", { contractDistributionsIndex: "index" }),
    filteredContractDistributions() {
      return this.contractDistributionsIndex.filter((cd) => cd.kitLink);
    },
  },
  async mounted() {
    await this.fetchContractDistributions({
      storeId: this.selectedStoreId,
      page: 1,
    });
  },
  methods: {
    ...mapActions("contractDistributions", { fetchContractDistributions: "fetchIndex", orderKit: "orderKit" }),
    ...mapActions("notifications", ["notify"]),

    async handleOrderKit(contractDistribution) {
      if (!window.confirm("Êtes-vous sûr de vouloir commander un kit ?")) return;

      const response = await this.orderKit({
        id: contractDistribution.id,
        storeId: this.selectedStoreId,
      });

      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Kit commandé avec succès",
      });
    },
  },
};
</script>
